import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import mixpanel from 'mixpanel-browser';
import { useForm } from 'react-hook-form';
import { Button, TextField, Link } from '@mui/material';

import { ModalPopup } from '../../components/Elements/Modal';

import { addingPartnerContacts, addPartnerContacts } from '../../actions';

import { Loader } from '../../components/Elements/Loader';
import { SubmittedPartner } from './SubmittedPartner';

import { HERO_IMAGE_ALT } from '../../constants/Careers';

import image from './TeamCollaborationUndraw.png';

import {
  EMPOWERING_LENDERS_WITH_DATA_DRIVEN_INSIGHTS,
  JOIN_OUR_NETWORK_OF_LENDERS_TO_ACCESS,
  SCHEDULE_A_DEMO,
  VIEW_PDF,
  SUBMIT,
  PARTNER_WITH_US_FORM,
} from '../../constants/Pages/PartnerWithUs';

import './PartnerHero.css';

export const PartnerHero = ({ user, token, loading, isSubmitted }) => {
  const [open, setIsOpen] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm();
  const dispatch = useDispatch();

  const handleScheduleDemo = () => {
    setIsOpen(true);
    mixpanel.track('Schedule Demo Form', {
      action: 'open',
    });
  };

  const handleSubmitPartnerForm = (val) => {
    dispatch(addingPartnerContacts);
    dispatch(addPartnerContacts({ body: { ...val, user }, token }));
  };

  const handleOnUpKeyMixPanelTracking = (formField) => {
    mixpanel.track('Partner With Us Form', {
      [formField]: getValues(formField),
      path: '/partner',
      userId: user?.id || user?.anonymousUserId,
    });
  };

  const handleViewSamplePDF = () => {
    mixpanel.track('View Sample Free Trial PDF', {
      path: '/partner',
      userId: user?.id || user?.anonymousUserId,
    });
  };

  const handleViewPDF = () => {
    mixpanel.track('View Partnership PDF', {
      path: '/partner',
      userId: user?.id || user?.anonymousUserId,
    });
  };

  return (
    <section className="partner-hero">
      <div className="partner-hero-container">
        <div className="partner-hero-image">
          <img src={image} alt={HERO_IMAGE_ALT} />
        </div>

        <div>
          <h1 className="partner-hero-header">{EMPOWERING_LENDERS_WITH_DATA_DRIVEN_INSIGHTS}</h1>
          <h5 className="hero-subheader">{JOIN_OUR_NETWORK_OF_LENDERS_TO_ACCESS}</h5>
          <div>
            <div>
              <ModalPopup
                buttonContent={
                  <Button
                    variant="outlined"
                    sx={{
                      '&:hover': { backgroundColor: 'black', color: 'white' },
                      '&:disabled': { backgroundColor: 'gray', color: 'black', opacity: 0.7 },
                      borderRadius: '10px',
                      height: '48px',
                      backgroundColor: 'black',
                      textTransform: 'initial',
                      color: 'white',
                    }}
                  >
                    {SCHEDULE_A_DEMO}
                  </Button>
                }
                modalContent={
                  <>
                    {isSubmitted ? (
                      <SubmittedPartner />
                    ) : (
                      <>
                        {' '}
                        <h2 className="partner-form-header">{SCHEDULE_A_DEMO}</h2>
                        <form className="partner-with-us-form">
                          {PARTNER_WITH_US_FORM.map(({ name, placeholder, required, pattern }) => {
                            return (
                              <div key={name} className="partner-input-wrapper">
                                <TextField
                                  className={name}
                                  name={name}
                                  error={!!errors[name]}
                                  helperText={errors[name]?.message}
                                  placeholder={placeholder}
                                  variant="outlined"
                                  autoComplete="off"
                                  sx={{
                                    backgroundColor: 'white',
                                    borderRadius: '10px',
                                    border: '1px solid gray',
                                  }}
                                  {...register(name, {
                                    required,
                                    pattern,
                                  })}
                                  disabled={loading}
                                  onKeyUp={(e) => {
                                    handleOnUpKeyMixPanelTracking(e.target.name);
                                  }}
                                />{' '}
                              </div>
                            );
                          })}

                          <div>
                            <Button
                              sx={{
                                '&:disabled': { color: 'white', opacity: 0.4 },
                                m: 0,
                                color: 'white',
                                backgroundColor: 'black',
                                width: '100%',
                                borderRadius: 2,
                                height: '56px',
                              }}
                              disabled={loading}
                              type="button"
                              onClick={handleSubmit(handleSubmitPartnerForm)}
                            >
                              {loading ? <Loader /> : SUBMIT}
                            </Button>
                          </div>
                          <div className="download-pdf-link-wrapper">
                            <div className="already-requested-trial">
                              Already Requested Free Trial?
                            </div>
                            <Link
                              variant="body2"
                              underline="none"
                              sx={{ fontFamily: 'sans-serif' }}
                              href="/partner/free_trial"
                            >
                              {' '}
                              Download The PDF{' '}
                            </Link>
                          </div>
                        </form>
                      </>
                    )}
                  </>
                }
                modalButtonId=""
                open={open}
                handleClose={() => {
                  setIsOpen(false);
                  mixpanel.track('Schedule Demo Form', {
                    action: 'close',
                  });
                }}
                handleOpen={handleScheduleDemo}
              />
            </div>
            <div>
              <Link
                variant="body2"
                underline="none"
                href="https://drive.google.com/file/d/1y0j8Y4rnK9KP10fxGeZtUPyosanP8zek/view?usp=sharing"
                color="black"
                target="_"
                onClick={handleViewSamplePDF}
              >
                View Free Trial Sample
              </Link>
            </div>
            <div>
              <Link
                variant="body2"
                underline="none"
                href={process.env.REACT_APP_PARTNERSHIP_PDF}
                color="black"
                target="_"
                onClick={handleViewPDF}
              >
                {VIEW_PDF}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
